import { render, staticRenderFns } from "./SpinnerModal.vue?vue&type=template&id=27b4d3da&scoped=true&lang=pug"
import script from "./SpinnerModal.vue?vue&type=script&lang=js"
export * from "./SpinnerModal.vue?vue&type=script&lang=js"
import style0 from "./SpinnerModal.vue?vue&type=style&index=0&id=27b4d3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b4d3da",
  null
  
)

export default component.exports